// Fire-and-forget CTA click tracker used by HomePage and PublicPreview.
// Never blocks user navigation: errors are swallowed so a broken beacon
// can't hurt conversion.
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function trackCta(source, action, programId) {
  try {
    const body = { source, action };
    if (programId) body.program_id = programId;
    axios
      .post(`${BACKEND_URL}/api/analytics/cta-click`, body, { timeout: 3000 })
      .catch(() => {});
  } catch (_) {
    /* ignore */
  }
}
